const edificiosData = [
]

export default edificiosData;